import { React, useEffect, useState } from 'react';
import { Paper, Typography, Grid, TextField, Autocomplete, CircularProgress, Button, Snackbar, Alert } from "@mui/material";
import { motion } from "framer-motion";
import axios from 'axios';
// Wrapper animation config
const fadeIn = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.4 },
};

const ProjectManager = () => {
    const [selectedServices, setSelectedServices] = useState([]);
    const [project, setProject] = useState({
        clientName: '',
        address: '',
        startDate: '',
        completionDate: '',
        services: "",
        photo: '',
        video: '',
    });
    const [services, setService] = useState([])
    const [loading1, setLoading1] = useState(false); // image loader
    const [loading2, setLoading2] = useState(false); // video loader
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const handleChange = (e) => {
        setProject({ ...project, [e.target.name]: e.target.value });
    };



    const handleSubmit = () => {
        const selectedTitles = selectedServices.map(service => service.title);

        axios({
            method: "POST",
            url: `${process.env.REACT_APP_MY_API}/api/projects`,
            data: { ...project, services: selectedTitles }
        }).then((res) => {
            setSnackbarOpen(true)

            // ✅ Reset form
            setProject({
                clientName: '',
                address: '',
                startDate: '',
                completionDate: '',
                services: '',
                photo: '',
                video: '',
            });

            // ✅ Reset selected services (assuming it's a useState variable too)
            setSelectedServices([]);

        }).catch((err) => {
            console.warn(err);
        });
    };



    useEffect(() => {
        const token = localStorage.getItem("token")
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_MY_API}/api/services/686154b5cbe093c404c97c5b`,
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((res) => {
            setService(res.data)
        }).catch((err) => {
            console.warn(err)
        })
    }, [])
    const uploadToCloudinary = async (file, type = 'image') => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

        const resourceType = type === 'video' ? 'video' : 'image';

        // Set loading based on type
        if (type === 'video') {
            setLoading2(true);
        } else {
            setLoading1(true);
        }

        try {
            const res = await axios.post(
                `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`,
                formData
            );
            return res.data.secure_url;
        } catch (err) {
            console.error('Upload Error:', err);
            return '';
        } finally {
            if (type === 'video') {
                setLoading2(false);
            } else {
                setLoading1(false);
            }
        }
    };

    const handleImageUpload = async (e) => {
        const url = await uploadToCloudinary(e.target.files[0], 'image');
        setProject((prev) => ({ ...prev, photo: url }));
    };

    const handleVideoUpload = async (e) => {
        const url = await uploadToCloudinary(e.target.files[0], 'video');
        setProject((prev) => ({ ...prev, video: url }));
    };


    return (
        <motion.div
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            transition={{ staggerChildren: 0.1 }}
        >
            <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 4 }}>
                <motion.div {...fadeIn}>
                    <Typography variant="h6" gutterBottom>
                        Add New Project
                    </Typography>
                </motion.div>

                <Grid container spacing={2} mt={1}>
                    {/* Client Name */}
                    <Grid item xs={12} sm={6}>
                        <motion.div {...fadeIn}>
                            <TextField fullWidth name="clientName" label="Client Name" value={project.clientName} onChange={handleChange} />
                        </motion.div>
                    </Grid>

                    {/* Address */}
                    <Grid item xs={12} sm={6}>
                        <motion.div {...fadeIn}>
                            <TextField fullWidth name="address" label="Address" value={project.address} onChange={handleChange} />
                        </motion.div>
                    </Grid>

                    {/* Start Date */}
                    <Grid item xs={12} sm={6}>
                        <motion.div {...fadeIn}>
                            <TextField
                                type="date"
                                fullWidth
                                name="startDate"
                                label="Start Date"
                                value={project.startDate}
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                            />
                        </motion.div>
                    </Grid>

                    {/* Completion Date */}
                    <Grid item xs={12} sm={6}>
                        <motion.div {...fadeIn}>
                            <TextField
                                type="date"
                                fullWidth
                                name="completionDate"
                                label="Completion Date"
                                value={project.completionDate}
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                            />
                        </motion.div>
                    </Grid>

                    {/* Services Dropdown */}
                    <Grid item xs={12}>
                        <motion.div {...fadeIn}>
                            <Autocomplete
                                multiple
                                fullWidth
                                disablePortal
                                options={services}
                                getOptionLabel={(option) => option.title}
                                isOptionEqualToValue={(option, value) => option._id === value._id}
                                value={selectedServices}
                                onChange={(event, newValue) => setSelectedServices(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label="Select Services"
                                        placeholder="Start typing..."
                                    />
                                )}
                                PaperComponent={({ children }) => (
                                    <Paper
                                        elevation={3}
                                        sx={{
                                            maxHeight: 250,
                                            overflowY: "auto",
                                            mt: 1,
                                            // 👇 Full width fix
                                            width: "100%",
                                            minWidth: "300px", // optional: ensures minimum width
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        {children}
                                    </Paper>
                                )}
                                ListboxProps={{
                                    sx: {
                                        maxHeight: "250px",
                                        overflowY: "auto",
                                        "& li": {
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                        },
                                    },
                                }}
                                sx={{
                                    width: "100%",
                                    "& .MuiAutocomplete-inputRoot": {
                                        paddingRight: "32px !important", // fix chip + caret alignment
                                    },
                                }}
                            />
                        </motion.div>
                    </Grid>



                    {/* Image Upload */}
                    <Grid item xs={12}>
                        <motion.div {...fadeIn}>
                            <Typography>Upload Image</Typography>
                            <input type="file" accept="image/*" onChange={handleImageUpload} />
                            {loading1 && <CircularProgress size={24} />}
                            {project.photo && (
                                <img
                                    src={project.photo}
                                    alt="Product"
                                    style={{ width: '100px', marginTop: '10px', borderRadius: '4px' }}
                                />
                            )}
                        </motion.div>
                    </Grid>

                    {/* Video Upload */}
                    <Grid item xs={12}>
                        <motion.div {...fadeIn}>
                            <Typography>Upload Video</Typography>
                            <input type="file" accept="video/*" onChange={handleVideoUpload} />
                            {loading2 && <CircularProgress size={24} />}
                            {project.video && (
                                <video
                                    controls
                                    width="200"
                                    src={project.video}
                                    style={{ marginTop: '10px', borderRadius: '4px' }}
                                />
                            )}
                        </motion.div>
                    </Grid>

                    {/* Submit Button */}
                    <Grid item xs={12}>
                        <motion.div {...fadeIn}>
                            <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleSubmit}>
                                Add Project
                            </Button>
                        </motion.div>
                    </Grid>
                </Grid>

                {/* Snackbar with MUI Alert */}
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                    <Alert severity="success" onClose={() => setSnackbarOpen(false)} sx={{ width: '100%' }}>
                        Project added successfully!
                    </Alert>
                </Snackbar>
            </Paper>
        </motion.div>
    );
};

export default ProjectManager;
